// extracted by mini-css-extract-plugin
export default {"table":"StockRequests_table__OvUmz","search":"StockRequests_search__JQagm","icons":"StockRequests_icons__uvm3j"};